/**
 * Menu e pulsanti per permesso: una sola matrice (PERMESSI di @qa/shared) per backend e frontend. I permessi di chi è
 * collegato sono l'unione dei suoi ruoli (MeDto.azioni, calcolati dal backend; in mancanza dai ruoli).
 */
import { puo, type Azione } from "@qa/shared";
import { useAuth } from "../auth/AuthContext";

export function usePuo() {
  const { me } = useAuth();
  return (a: Azione) => !!me && (me.azioni?.includes(a) ?? puo(me.ruoli, a));
}
